import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';

const CheckboxGroup = Checkbox.Group;
const useStyles = makeStyles(
  theme => ({
    filterDropdownBox: {
      minWidth: '164px',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      borderRadius: '2px',

      '& .ant-checkbox-group': {
        width: '100%',
        paddingTop: '4px',
        paddingBottom: '4px',
      },

      '& .ant-checkbox-wrapper': {
        display: 'block',
        margin: '0',
        paddingLeft: '12px',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontSize: '14px',
        lineHeight: '22px',

        color: 'rgba(0, 0, 0, 0.85)',
        '&:hover': {
          backgroundColor: theme.colors.gray3,
        },
      },
    },

    bottomBox: {
      ...theme.flex.center,
      justifyContent: 'space-between',
      borderTop: '1px solid #E8E8E8',
      padding: '10px 12px',
    },
    resetBtn: {
      cursor: 'pointer',
      fontSize: '12px',
      lineHeight: '22px',
      border: 'none',
      marginRight: '12px',
      borderRadius: '2px',
      paddingLeft: '8px',
      paddingRight: '8px',
      '&:hover': {
        backgroundColor: theme.colors.gray3,
      },
    },
    okbtn: {
      cursor: 'pointer',
      border: 'none',
      padding: '1px 8px',
      background: '#38B2A6',
      fontSize: '12px',
      lineHeight: '22px',
      color: theme.colors.gray1,
      borderRadius: '2px',
      ...theme.flex.center,
    },
    disabledbtn: {
      color: theme.colors.disableColor,
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
  }),
  { name: 'FilterDropdown' },
);
const FilterDropdown = props => {
  const classes = useStyles();
  const { options, closeBox, submitHandle, filterDropdownVisible } = props;
  const [submitedList, setSubmitedList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [isResetbtnDisabled, setResetbtnDisabled] = useState(true);
  const [chooseItems, setChooseItems] = useState([]);
  const onChange = checkedList => {
    setCheckedList(checkedList);
    setChooseItems(checkedList);
  };
  useEffect(() => {
    if (filterDropdownVisible) {
      if (submitedList.length === 0) {
        setCheckedList([]);
      }
      if (submitedList.length) {
        setCheckedList(submitedList);
      }
    }
  }, [filterDropdownVisible]);
  return (
    <div className={classes.filterDropdownBox}>
      <CheckboxGroup options={options} value={checkedList} onChange={onChange} />
      <div className={classes.bottomBox}>
        <button
          className={classNames(classes.resetBtn, { [classes.disabledbtn]: isResetbtnDisabled })}
          onClick={() => {
            if (!isResetbtnDisabled) {
              setSubmitedList([]);
              setCheckedList([]);
              submitHandle?.([]);
              setChooseItems([]);
              closeBox?.();
              setResetbtnDisabled(true);
            }
          }}
          disabled={checkedList?.length === 0}
        >
          Reset
        </button>
        <button
          className={classes.okbtn}
          onClick={() => {
            setSubmitedList(checkedList);
            setResetbtnDisabled(checkedList.length === 0 ? true : false);
            submitHandle?.(chooseItems);
            closeBox?.();
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};
FilterDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  submitHandle: PropTypes.func,
  closeBox: PropTypes.func,
  filterDropdownVisible: PropTypes.bool,
};
export default FilterDropdown;
